module.exports = __webpack_public_path__ + "static/yolcu-360-case-study-08d7f167fc809d09de8616670c407204.webp";